import React, { useState } from 'react';
import catLaughingGif from '../assets/Q4/cat-laughing.gif';

function Q4({ question = 4, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);
  const [noChecked, setNoChecked] = useState(false);

  return (
    <div className="dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I'm a different title</span>
        <h1>Project Valen</h1>
        <p>Well, do you?</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q4__center">
      <div className="q2__options q4__options">
        <label className="q2__option" htmlFor="q4-yes">
          <input
            id="q4-yes"
            type="checkbox"
            checked={false}
            onChange={() => setNoChecked(true)}
          />
          <span className="q2__option-label">Yes</span>
        </label>
        <label className="q2__option" htmlFor="q4-no">
          <input
            id="q4-no"
            type="checkbox"
            checked={noChecked}
            onChange={(e) => setNoChecked(e.target.checked)}
          />
          <span className="q2__option-label">No</span>
        </label>
      </div>
      <button
        type="button"
        className="dashboard__button dashboard__button--primary home__button q4__wave-button"
        onClick={() => onNavigate?.('q5')}
        disabled={!noChecked}
      >
        {noChecked ? 'Dunno' : 'Maybe'}
      </button>
      {noChecked && <img src={catLaughingGif} alt="" className="q4__gif" />}
    </div>
  </div>
  );
}

export default Q4;
